const initialState = {
    getCategoriesPending: false,
    getCategoriesFetched: false,
    categories: []
};


// Category slugs
// main
// happiness
// work
// sport
// main

const CategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_CATEGORIES_PENDING':
            return Object.assign({}, state, {
                getCategoriesPending: true,
                getCategoriesFetched: false,
            });

        case 'GET_CATEGORIES_FULFILLED': {

            let categories = action.payload;

            categories = categories.map( cat => {
                if (cat.packages && cat.packages.length) {
                    cat.packages = cat.packages.filter( pack => {
                        return pack.meditationsCount > 0;
                    });
                }
                return cat;
            }).filter( cat => {
                return cat.packages.length > 0;
            });

            return Object.assign({}, state, {
                getCategoriesPending: false,
                getCategoriesFetched: true,
                categories,
            });
        }

        case 'GET_CATEGORIES_REJECTED':
            return Object.assign({}, state, {
                getCategoriesPending: false,
                getCategoriesFetched: false,
            });

        case 'GET_CATEGORY_PENDING':
            return Object.assign({}, state, {
                getCategoriesPending: true
            });

        case 'GET_CATEGORY_FULFILLED':
            let categories = state.categories.splice();
            let existingCat = categories.find(cat => cat.id === action.payload.id);

            if (existingCat) {
                existingCat = action.payload;
            }
            else {
                categories.push(action.payload);
            }

            return Object.assign({}, state, {
                getCategoriesPending: false,
                categories: categories
            });

        case 'GET_CATEGORY_REJECTED':
            return Object.assign({}, state, {
                getCategoriesPending: false
            });

        default:
            return state;
    }
};

export default CategoryReducer;


// WEBPACK FOOTER //
// ./src/reducers/Category.js